import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

/**
 * 오늘출발 토글(체크박스) 클릭 시 발화.
 * iOS `LikedProductLoggerType.clickDeliveryFilter` → `CLICK_HEADLINE_XSMALL_ONE_LINE_TOGGLE`.
 * SCREEN 은 AnalyticsContext 에서 자동 주입.
 */
export const useLogClickDeliveryToggle = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    ({ isOn }: { isOn: boolean }) => {
      logAnalyticsEvent({
        name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_TOGGLE',
        analytics: {
          IS_ON: isOn,
          // iOS DeliveryType.fast.eventRawValue 와 동일 (오늘출발 토글)
          TOGGLE_TYPE: 'fast',
        },
      });
    },
    [logAnalyticsEvent],
  );
};
